// @ts-strict-ignore
import { Connection } from '@3d-scene/model3d/connection';
import { ArticleLocationVO } from '@article/model/vo/article-location.vo';

export class SelectedConnectionsReferenceArticleLocationVO extends ArticleLocationVO {
  public acceptingCubes: Connection[];

  public SelectedConnectionsReferenceArticleLocationVO() {
  }
}
